import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AppModule } from '../app.module';
import { environment } from 'src/environments/environment';
import { PreDocument } from '../types/pre-document';
import { Document } from '../types/document';
import { Company } from '../types/company';
import { AttachmentType } from '../types/attachment-type';
import {Proposal} from "../types/proposal";

@Injectable({
  providedIn: 'root'
})
export class FormService {
  preDocument!: PreDocument;
  document!: Document;
  proposalSignature ?: string;
  proposalId ?: number;
  companyTypeId ?: string;

  constructor(
      private appModule: AppModule,
      private http: HttpClient) { 
    this.clearData();
  }

  clearData() {
    this.preDocument = { };
    this.document = { id:0, company: {nip: '', krs: '', type: "OF_P_1", name: '' , personalData: {}, hqAddress: {}, contactData: {}, proxy: {}}};
  }

  getCompanyData(request: PreDocument): Observable<HttpResponse<Document>> {
    return this.http.post<Document>("api/document", request, {
      observe: 'response'});
  }
  
  uploadFile(file: File, documentId: number, attachmentType: AttachmentType, firstname?: string, surname?: string, pesel?: string, reasonType?: string) : Observable<any> {
    let formData = new FormData();
    
    formData.append('fileType', AttachmentType[attachmentType]);
    formData.append('documentId', String(documentId));
    if (firstname)
      formData.append('userName', firstname);
    if (surname)
      formData.append('userSurname', surname);
    if (pesel)
      formData.append('userId', pesel);
    if (reasonType)
      formData.append('reasonType', reasonType);
    formData.append('file', file);

    return this.http.post("api/file",
      formData,
      {
        reportProgress: true, 
        observe: 'events'
      });
  }
  
  sendProposal(document: Document) : Observable<any> {
    return this.http.put("api/document/" + document.id, document,{ observe: 'response' });
  }

  getDocuments() : Observable<HttpResponse<Proposal[]>> {
    return this.http.get<Proposal[]>("api/document",{ observe: 'response', params: {correction: false} });
  }

  getDocument(documentId: number, signed ?: boolean) : Observable<HttpResponse<Blob>> {
    return this.http.get("api/document/" + documentId, {responseType: 'blob', observe: 'response', params: {signed : signed ?? false}});
  }

  getSigningUrl(documentId : number) : Observable<any>{
    return this.http.get("api/signingURL/" + documentId, {observe: "response", responseType: "text"});
  }

}
